import { render, staticRenderFns } from "./WeightingData.vue?vue&type=template&id=5fa71428&scoped=true&"
import script from "./WeightingData.vue?vue&type=script&lang=js&"
export * from "./WeightingData.vue?vue&type=script&lang=js&"
import style0 from "./WeightingData.vue?vue&type=style&index=0&id=5fa71428&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fa71428",
  null
  
)

export default component.exports